<template></template>

<script>
    import axios from 'axios/index';

    export default {
        name: 'ImportarProcessosDigitalizados',
        components: { },
        data() { },
        methods: { },
        mounted() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            axios.get(`${urlApi}/v1/importarProcessosDigitalizados`, this.filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                responseType: 'arraybuffer'
            }).then( (response) => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
            })
        }
    }
</script>